<script setup lang="ts">
import { ref } from 'vue';

import { AppButton } from '@/shared/ui/button';

withDefaults(
  defineProps<{
    isVisible: boolean;
    isForced?: boolean;
  }>(),
  {
    isForced: false,
  },
);

const emit = defineEmits<{
  reload: [];
  dismiss: [];
}>();

const isReloading = ref(false);

const handleReload = () => {
  isReloading.value = true;
  // Перезагрузку может отменить диалог «Покинуть сайт?» о несохранённых изменениях: не оставляем кнопку крутиться.
  setTimeout(() => (isReloading.value = false), 10_000);
  emit('reload');
};

const handleDismiss = () => {
  emit('dismiss');
};
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform translate-y-[-100%] opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform translate-y-[-100%] opacity-0"
  >
    <div
      v-if="isVisible"
      class="animate-border-pulse fixed top-4 right-4 left-4 z-10000 max-w-md rounded-lg border-2 border-(--base-accent-color) bg-(--base-element-color) p-4 text-(--base-text-color) shadow-lg sm:left-auto"
      style="
        box-shadow:
          0 0 20px rgba(115, 103, 240, 0.3),
          0 0 40px rgba(115, 103, 240, 0.1);
      "
    >
      <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-1">
          <p class="leading-snug font-medium text-(--base-text-color)">
            {{ isForced ? 'Критическое обновление' : 'Доступна новая версия' }}
          </p>
          <p class="text-sm leading-snug text-(--base-popup-secondary-color)">
            {{
              isForced
                ? 'Обновите страницу: на старой версии работать нельзя'
                : 'Обновите страницу, чтобы получить последние изменения'
            }}
          </p>
        </div>
        <div class="flex items-center justify-end gap-2">
          <button
            v-if="!isForced"
            class="min-h-11 rounded-xl px-4 text-sm font-medium whitespace-nowrap text-(--base-popup-secondary-color) transition-[background-color,transform] duration-200 hover:bg-(--base-popup-hover-color) active:scale-[0.96]"
            @click="handleDismiss"
          >
            Отложить
          </button>
          <AppButton
            class="min-h-11 font-medium whitespace-nowrap"
            :loading="isReloading"
            @click="handleReload"
          >
            <span>Обновить</span>
          </AppButton>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
@keyframes border-pulse {
  0%,
  100% {
    box-shadow:
      0 0 20px rgba(115, 103, 240, 0.3),
      0 0 40px rgba(115, 103, 240, 0.1);
  }
  50% {
    box-shadow:
      0 0 30px rgba(115, 103, 240, 0.5),
      0 0 60px rgba(115, 103, 240, 0.2);
  }
}

.animate-border-pulse {
  animation: border-pulse 2s ease-in-out infinite;
}
</style>
